import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBackButtonUrl } from "../uiSlice";
import {
  PASS_PLAY_DEFAULT_CHARACTERS,
  savePassPlayPlayers,
} from "./passPlayStorage";
import { characterImageSrc } from "../game/useLobbyPvpFirestore";
import "../shiftTicTacToe/shiftTicTacToe.css";
import "./passPlayCreate.css";

const xCharacterPreview = characterImageSrc(
  PASS_PLAY_DEFAULT_CHARACTERS.xCharacter
);
const oCharacterPreview = characterImageSrc(
  PASS_PLAY_DEFAULT_CHARACTERS.oCharacter
);

function PassPlayCreate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [xName, setXName] = useState("");
  const [oName, setOName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    dispatch(setBackButtonUrl("/category"));
    const html = document.documentElement;
    const body = document.body;
    html.classList.add("category-page-bg");
    body.classList.add("category-page-bg");
    return () => {
      html.classList.remove("category-page-bg");
      body.classList.remove("category-page-bg");
    };
  }, [dispatch]);

  const handleContinue = (e) => {
    e.preventDefault();
    const trimmedX = xName.trim();
    const trimmedO = oName.trim();
    if (!trimmedX || !trimmedO) {
      setError("Please enter a name for both players.");
      return;
    }
    if (trimmedX.toLowerCase() === trimmedO.toLowerCase()) {
      setError("Player names must be different.");
      return;
    }
    setError("");
    try {
      sessionStorage.setItem("gameMode", "Pass & Play");
    } catch {
      // ignore
    }
    savePassPlayPlayers({
      xName: trimmedX,
      oName: trimmedO,
      xCharacter: PASS_PLAY_DEFAULT_CHARACTERS.xCharacter,
      oCharacter: PASS_PLAY_DEFAULT_CHARACTERS.oCharacter,
    });
    navigate("/game");
  };

  return (
    <section className="passplay-create" aria-label="Pass and Play setup">
      <div className="passplay-create__grid passplay-create__grid--top" aria-hidden="true" />
      <div className="passplay-create__grid passplay-create__grid--bottom" aria-hidden="true" />

      <div className="passplay-create__content">
        <div className="passplay-create__panel">
          <header className="passplay-create__header">
            <h1 className="passplay-create__title">Pass &amp; Play</h1>
            <p className="passplay-create__subtitle">
              Enter both player names, then share this device and take turns.
            </p>
          </header>

          <form className="passplay-create__form" onSubmit={handleContinue}>
            <label className="passplay-create__field passplay-create__field--x">
              <span className="passplay-create__field-head">
                {xCharacterPreview ? (
                  <img
                    src={xCharacterPreview}
                    alt=""
                    className="passplay-create__character-img"
                  />
                ) : (
                  <span className="passplay-create__mark passplay-create__mark--x" aria-hidden="true">
                    X
                  </span>
                )}
                <span className="passplay-create__label passplay-create__label--x">
                  Player X — Cross
                </span>
              </span>
              <input
                type="text"
                className="passplay-create__input"
                value={xName}
                onChange={(e) => setXName(e.target.value)}
                placeholder="First player name"
                maxLength={64}
                autoComplete="off"
                autoFocus
              />
            </label>

            <label className="passplay-create__field passplay-create__field--o">
              <span className="passplay-create__field-head">
                {oCharacterPreview ? (
                  <img
                    src={oCharacterPreview}
                    alt=""
                    className="passplay-create__character-img"
                  />
                ) : (
                  <span className="passplay-create__mark passplay-create__mark--o" aria-hidden="true">
                    O
                  </span>
                )}
                <span className="passplay-create__label passplay-create__label--o">
                  Player O — Nought
                </span>
              </span>
              <input
                type="text"
                className="passplay-create__input"
                value={oName}
                onChange={(e) => setOName(e.target.value)}
                placeholder="Second player name"
                maxLength={64}
                autoComplete="off"
              />
            </label>

            {error ? (
              <p className="passplay-create__error" role="alert">
                {error}
              </p>
            ) : null}

            <button
              type="submit"
              className="stt-btn stt-btn--primary passplay-create__submit"
            >
              Continue to game
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default PassPlayCreate;
